import { render, staticRenderFns } from "./engineering.vue?vue&type=template&id=68c8ee78&scoped=true&"
import script from "./engineering.vue?vue&type=script&lang=js&"
export * from "./engineering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c8ee78",
  null
  
)

export default component.exports